// @core/api/endpoints/calendar/update_event.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  EventResponse,
  UpdateEventRequest,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Update event
 * Updates event fields specified in the field mask. Changes trigger notifications to attendees if relevant fields are modified.
 */
export async function UpdateEvent(
  event_id: string,
  data: UpdateEventRequest,
  options?: RequestOptions
): Promise<EventResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/events/:event_id`;
  requestPath = requestPath.replace(':event_id', encodeURIComponent(event_id));
  const requestOptions = options;
  return client.put<EventResponse>(requestPath, data, requestOptions);
}
